<div class="bg-danger fixed top-0 right-0 left-0 h-8">
  <edu-beta-banner />
</div>

@if(initialLoadingService.isLoadingInitialData()) {
<div class="flex h-full items-center justify-center">
  <edu-loader />
</div>
} @else {
<div class="bg-page-glow flex h-full flex-col pt-8 md:flex-row">
  <div class="bg-card/60 border-line mr-0 hidden border p-2 md:block">
    <edu-sidebar
      [menuContents]="sidebarMenuItems()"
      (logout)="authService.logout()"
      [userResource]="userResourceService.user"
    >
      <ng-template #cta>
        <div class="w-full px-1.5 pt-4 pb-2">
          <edu-button
            [isFullWidth]="true"
            variant="secondary"
            [icon]="createWebinarCTAIcon"
            [routerLink]="['/webinars/new']"
          >
            {{ 'resources.webinar.actions.create' | transloco }}
          </edu-button>
        </div>
      </ng-template>
    </edu-sidebar>
  </div>
  <div #mobileMenuContainer class="z-10 order-last overflow-hidden md:hidden">
    <edu-mobile-menu [menuContents]="sidebarMenuItems()" />
  </div>
  <div class="flex min-h-0 flex-1 flex-col overflow-y-auto">
    <router-outlet />
  </div>
</div>
}
